module.exports = __webpack_public_path__ + "static/media/57.77660ebf.png";